import DownloadIcon from 'assets/images/icons/download-icon.webp';
import {Button, Modal} from 'letrus-ui';
import styles from './DownloadModal.module.scss';

export interface DownloadModalProps {
  onClose(): void;
  onSubmit(): void;
  message?: string;
  loading: boolean;
  fullfilled: boolean;
  disableDownload?: boolean;
}

function DownloadModal({
  onSubmit,
  onClose,
  message,
  fullfilled,
  loading,
  disableDownload,
}: DownloadModalProps): JSX.Element {
  const buttonText = fullfilled ? 'Pronto' : 'Download';

  return (
    <Modal
      id="downloadModal"
      title="Baixar conteúdo?"
      closeButton
      className={styles.modal}
    >
      <div className={styles.container}>
        <img alt="Ícone de Download" src={DownloadIcon} />
        <p data-testid="custom-message">{message}</p>
        <div className={styles.buttonDownload}>
          <Button
            onClick={fullfilled ? onClose : onSubmit}
            variant="primary"
            type="submit"
            loading={loading}
            disabled={loading || disableDownload}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DownloadModal;
